import { Epic, ofType, StateObservable } from 'redux-observable';
import { mergeMap, Observable } from 'rxjs';
import {
  ADD_PAYER_FROM_VOUCHER, addContact, SUBMIT_ADD_CONTACT, SubmitContact,
} from '../actions/Actions';
import { setPayer, setNewContactFlag, updateContactAddProcess } from '../../../actions/Actions';
import { IshState } from 'src/js/services/IshState';
import { openEditContact } from '../../contact-edit/actions/Actions';

/**
 * This epic process Init action of checkout application and define Phase of the application
 */
export const SubmitAddContact: Epic<any, IshState> = (action$: Observable<any>, store: StateObservable<IshState>): Observable<any> => {
  return action$.pipe(
    ofType(SUBMIT_ADD_CONTACT),
    mergeMap(action => {
      const payload: SubmitContact = action.payload;
      const state: IshState = store.value;
      const contact = {
        ...payload.contact,
        parentRequired: payload.parentRequired,
        updateData: payload.updateData
      };

      return [
        updateContactAddProcess(contact, state.checkout.phase, state.checkout.contactAddProcess.forChild),
        setNewContactFlag(payload.newContact),
        openEditContact(contact)
      ];
    })
  );
};

export const AddPayerFromVoucher: Epic<any, IshState> = (action$: Observable<any>): Observable<any> => {
  return action$.pipe(
    ofType(ADD_PAYER_FROM_VOUCHER),
    mergeMap(action => {
      const payload: SubmitContact = action.payload;

      return [
        addContact(payload.contact),
        setNewContactFlag(payload.newContact),
        setPayer(payload.contact.id),
      ];
    })
  );
};